import React from "react";
import { Card, Col, Container, Image, Row } from "react-bootstrap";
import PlaceHolder from "assets/placeholder.webp";
import { ArrowRightCircle } from "react-bootstrap-icons";

const Group = ({ group, onView }) => {
  return (
    <React.Fragment>
      <Card>
        <Card.Header className="position-relative p-0">
          <Container fluid className="text-center p-0 h-20vh">
            <Image
              className="w-100 h-100 object-fit-contain"
              src={group.image}
              onErrorCapture={({ currentTarget }) => {
                currentTarget.onerror = null; // prevents looping
                currentTarget.src = PlaceHolder;
              }}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null; // prevents looping
                currentTarget.src = PlaceHolder;
              }}
            />
          </Container>
        </Card.Header>
        <Card.Body>
          <Row className="justify-content-between">
            <Col xs={10}>
              <h6 className="w-auto">{group.name}</h6>
            </Col>
            <Col xs={2}>
              <ArrowRightCircle
                onClick={() => onView(group)}
                size={30}
                color="firebrick"
                className="w-auto cursor-pointer"
              />
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </React.Fragment>
  );
};

export default Group;
